import React, { ReactNode } from 'react';
import { Box, TableCell, TableCellProps } from '@mui/material';
import { COLORS_COOLGRAY, COLORS_GRAY_BORDER } from '../../../App.constants';
import { LoaderBox } from '../../benchmarks/LoaderBox';

interface IProps extends TableCellProps {
  children?: ReactNode;
  isCenter?: boolean;
  shouldHide?: boolean;
}

export const CustomTableCell: React.FC<IProps> = (props) => {
  const { isCenter = false, ...muiProps } = props;
  return (
    <TableCell
      {...muiProps}
      sx={{
        borderBottom: '0px solid transparent',
        borderTop: '0px solid transparent',
        borderLeft: isCenter ? `1px solid ${COLORS_GRAY_BORDER}` : undefined,
        borderRight: isCenter ? `1px solid ${COLORS_GRAY_BORDER}` : undefined,
        color: COLORS_COOLGRAY,
        ...muiProps.sx,
      }}
    >
      {!props.shouldHide && props.children}
      {props.shouldHide && (
        <Box
          width={'100%'}
          height={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <LoaderBox display={'inline'} />
        </Box>
      )}
    </TableCell>
  );
};

CustomTableCell.displayName = 'CustomTableCell';
